export const ERROR_STATUSES = {
	NOT_ALLOWED: "NotAllowed",
	INVALID_PARAMETERS: "InvalidParameters"
};
